import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

const SnackBarStyles = makeStyles((theme: Theme) =>
    createStyles({
        snackBarWrapper: {
            padding: theme.spacing(2),
            borderRadius: 6,
            backgroundColor: theme.palette.background.blue,
        },
        snackBarHeader: {
            display: "flex",
            alignItems: "center",
            marginBottom: theme.spacing(0.8),
            "& .MuiIconButton-root": {
                marginLeft: "auto",
                padding: 0,
            },
        },
        snackBarTitle: {
            padding: theme.spacing(0, 1),
        },
        backdrop: {
            backdropFilter: "blur(5px)",
            top: "108px",
            left: "284px",
        },
    })
);

export default SnackBarStyles;
